import { defineMessages } from 'react-intl';

export const imageGalleryMessages = defineMessages({
  zoom: {
    id: 'imageGallery.aria.zoom',
    defaultMessage: 'Vollbildzoom öffnen',
  },
  ariaNextImage: {
    id: 'imageGallery.aria.nextImage',
    defaultMessage: 'nächstes Bild',
  },
  ariaPrevImage: {
    id: 'imageGallery.aria.prevImage',
    defaultMessage: 'vorheriges Bild',
  },
});
